module.exports = __webpack_public_path__ + "img/generic-type-struct.c713b8b9.jpg";